import Vue from "vue";
import Spinner from "./Spinner.vue";
export default Vue.extend({
    components: { Spinner },
    name: "Button",
    props: {
        variant: {
            type: String,
            validator: (v) => ["ultimate", "primary", "secondary", "quiet", ""].includes(v),
            default: "",
        },
        prependIcon: {
            type: String,
            default: "",
        },
        appendIcon: {
            type: String,
            default: "",
        },
        large: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        block: {
            type: Boolean,
            default: false,
        },
        href: {
            type: String,
            default: null,
        },
        newTab: {
            type: Boolean,
            default: false,
        },
        to: {
            type: Object,
            default: null,
        },
        normal: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        loadingText: {
            type: String,
            default: "Loading...",
        },
        loadingClass: {
            type: String,
            default: "text-white",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        text: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isHyperlink() {
            return this.href !== null || this.to !== null;
        },
        tag() {
            if (this.to !== null)
                return "router-link";
            if (this.href !== null)
                return "a";
            return "button";
        },
        buttonClasses() {
            return {
                btn: true,
                [`btn-${this.variant}`]: true,
                "btn-small": this.small,
                "btn-large": this.large,
                "btn-block": this.block,
                "btn-normal": this.normal,
                "btn-loading": this.loading,
                "btn-text": this.text,
                "btn-icon": this.icon,
                "btn-dense": this.dense,
            };
        },
    },
});
